"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.autoAIGetRequest = autoAIGetRequest;
exports.autoAIPostRequest = autoAIPostRequest;
async function autoAIGetRequest(branchId, userId, start, end) {
    // Start and end are dates with format YYYYMMDD
    // A task is identified by (userId, branchId, start, end)
    const url = `/dashboard/${userId}/autoai/${start}/${end}?c=${branchId}`;
    try {
        const res = await fetch(url, {
            method: "GET",
            headers: { "Content-Type": "application/json", },
            cache: "no-store",
        });
        return await res.json();
    }
    catch (err) {
        throw new Error();
    }
}
async function autoAIPostRequest(branchId, userId, payload) {
    const url = `/dashboard/${userId}/autoai?c=${branchId}`;
    const data = new URLSearchParams({
        list: payload.list,
        date: payload.date,
        until: payload.until,
        tags: payload.tags,
        autoSel: payload.autoSel,
        speed: payload.speed.toString(),
        instructions: payload.instructions,
    });
    try {
        const res = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: data.toString(),
        });
        if (!res.ok) {
            throw new Error();
        }
        return await res.json();
    }
    catch (err) {
        throw err;
    }
}
